<template>
  <div>
    <tool-bar :title="title"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <div class="margin-top-20">
      <div class="item-heading-desc-div margin-left-10 margin-right-10">
        <weex-text
          class="item-heading"
          v-html="alternatePANHeading"
        ></weex-text>
      </div>

      <file-attach-button
        class="horizontal_center margin_top_40"
        size="medium"
        file-attach-button-id="upload_alternate_pan"
        :show-attach-description="showFieldError('alternate_pan_uploaded')"
        :attach-description="getErrorMsg('alternate_pan_uploaded')"
        text="Upload Corporate PAN"
        :attach-image-des-src="documentAttachImage"
        :enabled-text-style="attachFileButtonTextStyle"
        :enabled-btn-style="attachFileButtonStyle"
        @filesAttached="onAlternatePANAttached"
      ></file-attach-button>

      <wxc-button
        text="Next"
        class="margin-top-40 margin-bottom-20 horizontal_center"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import ToolBar from "../layout/ToolBar";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import Loading from "../layout/Loading";
import StageCommentItem from "../layout/StageCommentItem";
import { Activities } from "../../utils/ActivityNavigator";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import FileAttachButton from "../layout/FileAttachButton";
import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import AlertService from "../core/alert/AlertService";
import { EntityType } from "../../utils/EntityType";
import { DocumentDescription } from "../../utils/DocumentDetails";
import DynamicFieldUtils, { FieldTypes } from "../../utils/DynamicFieldUtils";

const DOCUMENT_UPLOADED = "Document uploaded successfully";

const ALL_FIELDS_DATA = {
  alternate_pan_uploaded: {
    validation: "",
    fieldType: FieldTypes.BUTTON,
    errorMsg: "<div style='color: red; font-size: 14px; text-align: center'>Please upload Corporate PAN</div>",
    optional: false
  }
};

export default {
  name: "AlternatePANActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    ErrorAlertItem,
    Loading,
    StageCommentItem,
    FileAttachButton,
    WxcButton
  },

  data: () => ({
    title: "Proprietor/Corporate PAN",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    invalidFields: [],
    alternatePANDetails: {
      alternate_pan_uploaded: false
    }
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onInputEntered(key, value) {
      this.alternatePANDetails[key] = value;
      this.removeFromInvalidFieldsIfValid(key);
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
        this.invalidFields,
        key,
        this.alternatePANDetails[key],
        ALL_FIELDS_DATA,
        ALL_FIELDS_DATA
      );
    },

    getFieldLabel(key) {
      return ALL_FIELDS_DATA[key]["label"];
    },

    showFieldError(fieldKey) {
      return this.invalidFields && this.invalidFields.includes(fieldKey);
    },

    getFieldValue(key) {
      return this.alternatePANDetails ? this.alternatePANDetails[key] : "";
    },

    getErrorMsg(fieldKey) {
      return ALL_FIELDS_DATA[fieldKey]["errorMsg"];
    },

    onAlternatePANAttached(e) {
      const file = e.files[0];
      this.loading = true;
      DataSource.createDocument(
        EntityType.LOANS,
        LoanScopeDataHolder.getLoanId(),
        DocumentDescription.ALTERNATE_PAN.name,
        DocumentDescription.ALTERNATE_PAN.description,
        DocumentDescription.ALTERNATE_PAN.directory,
        file
      )
        .then(createDocumentRes => {
          this.loading = false;
          if (createDocumentRes.errorOccurred) {
            this.showError(createDocumentRes.data);
          } else {
            this.onInputEntered("alternate_pan_uploaded", true);
            this.showToast(DOCUMENT_UPLOADED);
          }
        })
    },

    onSubmit() {
      this.invalidFields = [];
      if (this.checkForValidation()) {
        this.completeCurrentTaskAndGetNextTask();
      }
    },

    checkForValidation() {
      this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
        this.alternatePANDetails,
        ALL_FIELDS_DATA,
        ALL_FIELDS_DATA
      );

      return !this.invalidFields || this.invalidFields.length === 0;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    }
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.ALTERNATE_PAN];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    alternatePANHeading() {
      return "Upload Proprietor /Corporate PAN Card";
    },

    documentAttachImage() {
      return this.alternatePANDetails.alternate_pan_uploaded
        ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
        : ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
    },

    attachFileButtonTextStyle() {
      return { color: "#ffffff" };
    },

    attachFileButtonStyle() {
      return {
        "background-color": "#f87246",
        "border-width": "1px",
        "border-style": "solid",
        "border-color": "gray"
      };
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

